function load_cart(data_remove_line){
  // no-store: the section and /cart.js responses are otherwise served from the
  // HTTP cache on repeat calls, so the drawer keeps rendering a stale cart
  // (a discount code applied twice in one session appeared to do nothing).
  return fetch(window.Shopify.routes.root +'?section_id=cart-drawer', { cache: 'no-store' })
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    initUSPCarousel();
    if (window.Rebuy && typeof window.Rebuy.init === 'function') {
      setTimeout(() => { Rebuy.init(); }, 500);
    }
    // document.querySelectorAll('.item-remove').forEach(function(cartRemove){
    //   cartRemove.addEventListener('click',(evt) => {
    //     evt.preventDefault();
    //     var data_line = cartRemove.dataset.line;
    //     // alert(data_line)
    //     removeItem(data_line,cartRemove)
    //     // removeItem(data_line)
    //   });
    // });
    document.querySelectorAll('.header-cart button').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector(".cart_popup").innerHTML = '';
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter','open-wishlist');
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close button').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter','open-wishlist');
      });
    });
    const url = '/cart.js';
    return fetch(url, { cache: 'no-store' })
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(cart_count>0){
        if(document.querySelectorAll('.item-row[data-properties]').length > 0){
          document.querySelector('.cart-count').innerHTML = cart_count - document.querySelectorAll('.item-row[data-properties]').length;
        }else{
          document.querySelector('.cart-count').innerHTML = cart_count;
        }
      }else{
      	document.querySelector('.cart-count').innerHTML = '';
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
$(document).on('click','.item-remove',function(e){
  e.preventDefault();
  let data_line = $(this).attr('data-line');
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    if($(this).parents('.item-row').hasClass('has-gift')){
      let thisID = $(this).parents('.has-gift').getAttribute('data-id');
      let get_property = document.querySelector('.item-row[data-properties="'+ thisID +'"]').getAttribute('data-properties')
      let giftID = document.querySelector('.item-row[data-properties="'+ thisID +'"]').getAttribute('data-id')
      let giftLine = document.querySelector('.item-row[data-properties="'+ thisID +'"] .item-remove').getAttribute('data-line')
      if(thisID == get_property){
        let dataVal = {'line': giftLine ,'quantity': 0 };
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(dataVal),
        })
        .then((response) => response.json())
        .then((data) => {
          if(document.location.href.indexOf('/cart') > -1) {
            // window.location.href = "/cart";
            $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
              window.history.pushState({}, null, '/cart');  
            });
          }else{
            load_cart();
          }
        })
        .catch((error) => {
          console.log('Error:', error);
        });
      }
    }else{
      if(document.location.href.indexOf('/cart') > -1) {
        // window.location.href = "/cart";
        $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
          window.history.pushState({}, null, '/cart');  
        });
      }else{
        load_cart();
      }
      // load_cart();
    }
    if(document.location.href.indexOf('/cart') > -1) {
      // window.location.href = "/cart";
      $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
        window.history.pushState({}, null, '/cart');  
      });
    }else{
      load_cart();
    }
  })
  .catch((error) => {
    console.error('Error1:', error);
  });
})
// function removeItem(data_line,cartRemove){
//   const data = {'line': data_line ,'quantity': 0 };
//   fetch('/cart/change.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(data),
//   })
//   .then((response) => response.json())
//   .then((data) => {
//     if(cartRemove.closest('.has-gift')){
//       let thisID = cartRemove.closest('.has-gift').getAttribute('data-id');
//       let get_property = document.querySelector('.item-row[data-properties="'+ thisID +'"]').getAttribute('data-properties')
//       let giftID = document.querySelector('.item-row[data-properties="'+ thisID +'"]').getAttribute('data-id')
//       let giftLine = document.querySelector('.item-row[data-properties="'+ thisID +'"] .item-remove').getAttribute('data-line')
//       if(thisID == get_property){
//         let dataVal = {'line': giftLine ,'quantity': 0 };
//         fetch('/cart/change.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(dataVal),
//         })
//         .then((response) => response.json())
//         .then((data) => {
//           if(document.location.href.indexOf('/cart') > -1) {
//             // window.location.href = "/cart";
//             $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
//               window.history.pushState({}, null, '/cart');  
//             });
//           }else{
//             load_cart();
//           }
//         })
//         .catch((error) => {
//           console.log('Error:', error);
//         });
//       }
//     }else{
//       if(document.location.href.indexOf('/cart') > -1) {
//         // window.location.href = "/cart";
//         $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
//           window.history.pushState({}, null, '/cart');  
//         });
//       }else{
//         load_cart();
//       }
//       // load_cart();
//     }
//     if(document.location.href.indexOf('/cart') > -1) {
//       // window.location.href = "/cart";
//       $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
//         window.history.pushState({}, null, '/cart');  
//       });
//     }else{
//       load_cart();
//     }
//   })
//   .catch((error) => {
//     console.error('Error1:', error);
//   });
// }
$(document).ready(function(){
  $(document).on('click','.add-disc .add-desc-inner',function(e){
    var $coupon = $(this).closest('.cart-coupon');
    if($coupon.length){
      $coupon.addClass('is-open');
      $coupon.find('[data-discount-input]').trigger('focus');
    }else{
      $(this).hide();
      $('.drawer-footer').addClass('active');
      $('.cp-right-inr').addClass('active');
    }
  });
});

$(document).on('click','[data-discount-apply]',function(){
  applyEnteredDiscount($(this).closest('.cart-coupon'));
});
$(document).on('keydown','[data-discount-input]',function(e){
  if(e.key === 'Enter'){
    e.preventDefault();
    applyEnteredDiscount($(this).closest('.cart-coupon'));
  }
});
$(document).on('click','[data-discount-remove]',function(){
  var $coupon = $(this).closest('.cart-coupon');
  if($coupon.hasClass('is-loading')) return;
  var removeCode = ($(this).attr('data-discount-remove') || '').toLowerCase();
  var codes = appliedCouponCodes($coupon).filter(function(c){ return c.toLowerCase() !== removeCode; });
  setCartDiscounts($coupon, codes.join(','), null);
});

function appliedCouponCodes($coupon){
  var raw = ($coupon.attr('data-applied-codes') || '').trim();
  if(!raw) return [];
  return raw.split(',').map(function(c){ return c.trim(); }).filter(Boolean);
}

function applyEnteredDiscount($coupon){
  if($coupon.hasClass('is-loading')) return;
  var $input = $coupon.find('[data-discount-input]');
  var code = ($input.val() || '').trim();
  $coupon.find('[data-discount-message]').prop('hidden', true);
  if(!code){ $input.trigger('focus'); return; }
  var codes = appliedCouponCodes($coupon);
  var exists = codes.some(function(c){ return c.toLowerCase() === code.toLowerCase(); });
  if(!exists) codes.push(code);
  setCartDiscounts($coupon, codes.join(','), code);
}

function updateCartDiscountString(discountString){
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    cache: 'no-store',
    body: JSON.stringify({ discount: discountString })
  })
  .then(function(response){ return response.json(); });
}

function setCartDiscounts($coupon, discountString, codeToValidate){
  var previousString = appliedCouponCodes($coupon).join(',');
  $coupon.addClass('is-loading');
  return updateCartDiscountString(discountString)
  .then(function(cart){
    if(codeToValidate && !discountCodeApplied(cart, codeToValidate)){
      // /cart/update.js keeps whatever discount string it was sent, applicable or
      // not. Put the previously applied codes back so the cart matches what the
      // drawer shows -- otherwise the rejected code stays in the cart and every
      // later attempt at it fails until the page is fully reloaded.
      return updateCartDiscountString(previousString).then(function(){
        $coupon.removeClass('is-loading');
        $coupon.find('[data-discount-message]').prop('hidden', false);
      });
    }
    return load_cart();
  })
  .catch(function(error){
    console.error('Discount error:', error);
    $coupon.removeClass('is-loading');
    $coupon.find('[data-discount-message]').prop('hidden', false);
  });
}

function discountCodeApplied(cart, code){
  var target = (code || '').trim().toLowerCase();
  if(!target) return false;
  // cart.discount_codes is the cart's own record of every code it holds, with
  // applicable:false on the ones Shopify rejected. App-issued codes (Yotpo
  // loyalty vouchers) can land here before they show up in the discount
  // applications below, so check it first to avoid a false rejection.
  var enteredCodes = cart.discount_codes || [];
  for(var k=0; k<enteredCodes.length; k++){
    var entry = enteredCodes[k] || {};
    if((entry.code || '').toLowerCase() === target) return entry.applicable !== false;
  }
  var cartApps = cart.cart_level_discount_applications || [];
  var found = cartApps.some(function(app){
    return app && app.type === 'discount_code' && (app.title || '').toLowerCase() === target;
  });
  if(found) return true;
  var items = cart.items || [];
  for(var i=0; i<items.length; i++){
    var allocations = items[i].line_level_discount_allocations || [];
    for(var j=0; j<allocations.length; j++){
      var app = allocations[j].discount_application || {};
      if((app.title || '').toLowerCase() === target) return true;
    }
  }
  return false;
}

function initUSPCarousel() {
  const uspCarousel = document.querySelector('.usps--carousel');
  const uspCarouselInner = uspCarousel?.querySelector('.usps__track');

  if (!uspCarousel || !uspCarouselInner) return;

  uspCarousel.classList.add('usps--active');

  const originalItems = Array.from(uspCarouselInner.children);

  let contentWidth = uspCarouselInner.scrollWidth;
  const containerWidth = uspCarousel.offsetWidth;

  // Keep cloning until we have enough content to loop smoothly
  while (contentWidth < containerWidth * 2) {
    originalItems.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      uspCarouselInner.appendChild(clone);
    });

    contentWidth = uspCarouselInner.scrollWidth;
  }
}